var map = {
  "./": "74788",
  "./edit": "83326",
  "./edit.js": "83326",
  "./index": "74788",
  "./index.js": "74788",
  "./new": "59246",
  "./new.js": "59246",
  "./show": "23783",
  "./show.js": "23783"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 80752;
